import { Card, CardBody, Col } from "reactstrap";
import CardHeaderCommon from "../../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import { BalanceHeading } from "../../../../utils/Constant";
import { H3, P, Progressbar } from "../../../../AbstractElements";
import CardHolder from "./CardHolder";
import BalanceLimit from "./BalanceLimit";

const Balance = () => {
  return (
    <Col xxl="3" md="6" className="box-col-6 proorder-xl-11 proorder-lg-10">
      <Card className="main-balance">
        <CardHeaderCommon title={BalanceHeading} />
        <CardBody className="pt-0">
          <P className="m-0 f-w-600">Main Balance</P>
          <H3>$10,843,372</H3>
          <Progressbar className="bg-light-primary" color="primary" value={45} />
          <CardHolder />
          <BalanceLimit />
        </CardBody>
      </Card>
    </Col>
  );
};

export default Balance;
